import Acrylic from "components/Acrylic"
import type { NextPage, NextPageContext } from "next"
import Link from "next/link"
import showdown from "showdown"

import Header from "sections/Header"

const converter = new showdown.Converter()

type Props = {changelog?: string}

const AboutPage: NextPage<Props> = ({changelog}) => {
	return (
		<div className="w-full max-w-6xl mx-auto py-2 px-1 flex flex-col gap-1">
			<Header />
			<div className="w-full flex flex-col sm:flex-row pt-8 sm:justify-between items-center sm:items-start gap-4 mb-12">
				<Acrylic className="w-96 p-3 rounded flex flex-col gap-4">
					<h2 className="text-xl font-medium">About</h2>
					<p className="leading-snug">
						GradientHub is a place to create and share CSS
						gradients. It is a project by{" "}
						<Link href="https://thomaseckert.dev">
							<span className="underline underline-offset-2 cursor-pointer">
								Thomas Eckert
							</span>
						</Link>
						.
					</p>
					<p>
						The project is under active development. If you have
						feedback, please submit it{" "}
						<Link href="/feedback">
							<span className="underline cursor-pointer">
								here
							</span>
						</Link>
						.
					</p>
				</Acrylic>

				{changelog &&
				<Acrylic className="w-96 p-3 rounded flex flex-col gap-4 flex-1">
					<article dangerouslySetInnerHTML={{ __html: changelog }} />
				</Acrylic>
				}
			</div>

			<div
				className="fixed -top-[150vh] -left-[100vw] -z-10 h-[200vh] w-[200vw] -rotate-12 overflow-clip"
				style={{
					background:
						"radial-gradient(circle, rgba(2,0,36,1) 0%, rgba(9,121,97,0.7044123960344979) 23%, rgba(0,212,255,1) 100%)",
				}}
			/>
		</div>
	)
}

export const getServerSideProps = async (context: NextPageContext) => {
	const url = process.env["NEXT_PUBLIC_URL"]
	const response = await fetch(`${url}/changelog.md`)
	const markdown = (response.ok && (await response.text())) as string	
	const changelog = converter.makeHtml(markdown)

	return {props:{changelog}}
}

export default AboutPage
